import PropTypes from 'prop-types';
import React from 'react';

import Achievement from '../ListItem';
import styles from './chain.scss';

const propTypes = {
  chain: PropTypes.shape(),
  onClick: PropTypes.func,
  debug: PropTypes.oneOfType([
    PropTypes.shape({
      award: PropTypes.func,
      withdraw: PropTypes.func,
    }),
    PropTypes.bool,
  ]),
};

const Chain = ({ chain, onClick, debug }) => (chain ? (
  <div className={styles.container}>
    {chain
      .get('items')
      .map((achievement) => (
        <Achievement
          key={achievement.get('id')}
          achievement={achievement}
          earnedAt={achievement.get('earned_at')}
          onClick={() => onClick(achievement)}
          debug={debug}
        />
      ))}
  </div>
) : null);

Chain.propTypes = propTypes;
export default Chain;
